import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicePageShell from '../../components/ServicePageShell';
import MahalStatic from './MahalStatic';

const Mahal = () => (
  <ServicePageShell
    strapiApiId="service-mahal"
    defaultTitle="Mahal"
    StaticFallback={MahalStatic}
    fadeTriggerOnce={false}
  />
);

export default Mahal;
